// LIBRERIE/IMPORTS
import React from "react";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";
import he from 'he';
//import appConfig from "../../config/appConfig";

// HOOKS
import { useGetAgentsByAgency } from "../../hooks/useGetAgents";
import { useGetAgencyDetails } from "../../hooks/useGetAgencyDetails";

// COMPONENTI
import SubHeaderDefault from "../Header/subHeader/SubHeaderDefault";
import AgentsSection from "./AgentsSection";
import ServerError from "../Error/ServerError";
import LoadingIndicator from "../Loaders/LoadingIndicator";
//import WidgetContacts from "../Widgets/WidgetContacts/WidgetContacts";
//import WidgetPartners from "../Widgets/WidgetPartners/WidgetPartners";

interface AboutUsProps {
    agencyId: number;
    showAgents: boolean;
}

const AboutUs: React.FC<AboutUsProps> = ({ agencyId, showAgents }) => {
    const { t } = useTranslation();
    //const partners = appConfig.content.partners;
    const { agents, loading: agentsLoading, error: agentsError } = useGetAgentsByAgency(agencyId);
    const { agency, loading: agencyLoading, error: agencyError } = useGetAgencyDetails(agencyId);

    if (agencyLoading) return <LoadingIndicator />;
    if (agencyError) return <ServerError />;
    if (agentsLoading && showAgents) return <LoadingIndicator />;
    if (agentsError && showAgents) console.error("Error fetching agents:", agentsError);

    return (
        <>
            <Helmet>
                <title>{t('aboutUsPage.pageTitle')} | {he.decode(`${agency?.agencyName}`) || 'Agenzia Immobiliare'}</title>
                <link rel="preconnect" href="https://fonts.googleapis.com" />
                <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
                <link href="https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,400;0,600;0,700;1,400&family=Lato:wght@300;400&display=swap" rel="stylesheet" />
            </Helmet>

            <SubHeaderDefault title={t('aboutUsPage.subHeaderTitle')} isSeo={true} />

            <main id="about-us-page" className="space-ptb position-relative">
                <div className="container-fluid w-special">
                    <h2 dangerouslySetInnerHTML={{ __html: t('aboutUsPage.title') as string }} className="mb-4" />
                    <div className="row align-items-center">
                        <div className="col-12 col-lg-8 mb-4 mb-lg-0">
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para1') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para2') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para3') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para4') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para5') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para6') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para7') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para8') as string }} />
                            <p dangerouslySetInnerHTML={{ __html: t('aboutUsPage.para9') as string }} />
                        </div>
                        <div className="col-12 col-lg-4 my-3 text-center">
                            <img className="img-fluid img-shadow" src="/assets/images/altrePag/aboutUs2.webp" alt="Domenici Immobiliare" />
                        </div>
                        <div className="col-12 mb-4">
                            <h3 className="mb-4">{t('aboutUsPage.subTitle1')}</h3>
                            <ul className="list-unstyled">
                                <li className="mb-3">
                                    <p className="mb-1"><strong>{t('aboutUsPage.list1Title')}</strong></p>
                                    <ul>
                                        <li>{t('aboutUsPage.list1Item1')}</li>
                                        <li>{t('aboutUsPage.list1Item2')}</li>
                                        <li>{t('aboutUsPage.list1Item3')}</li>
                                    </ul>
                                </li>
                                <li className="mb-3">
                                    <p className="mb-1"><strong>{t('aboutUsPage.list2Title')}</strong></p>
                                    <ul>
                                        <li>{t('aboutUsPage.list2Item1')}</li>
                                        <li>{t('aboutUsPage.list2Item2')}</li>
                                    </ul>
                                </li>
                                <li className="mb-1">
                                    <p className="mb-2"><strong>{t('aboutUsPage.list3Title')}</strong></p>
                                    <ul>
                                        <li>{t('aboutUsPage.list3Item1')}</li>
                                        <li>{t('aboutUsPage.list3Item2')}</li>
                                        <li>{t('aboutUsPage.list3Item3')}</li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                        <div className="col-12 col-xl-6 text-center">
                            <img className="img-fluid mb-4 mb-xl-0 img-shadow" src="/assets/images/altrePag/agenzia.webp" alt="Agenzia Immobiliare Domenici" />
                        </div>
                        <div className="col-12 col-xl-6 text-center">
                            <img className="img-fluid img-shadow" src="/assets/images/altrePag/agenzia2.webp" alt="Agenzia Immobiliare Domenici" />
                        </div>
                    </div>
                    <AgentsSection
                        showAgents={showAgents}
                        agents={agents}
                        agentsLoading={agentsLoading}
                        agentsError={agentsError}
                    />
                </div>
            </main>
        </>
    );
};
export default AboutUs;